<template>
	<div class="customize-theme">
		<v-card>
			<v-card-text>
				<section class="mb-3">
					<h3 class="fs--22 fw--400">Customize Theme</h3>
					<p class="fieldFore--text fs--12 fw--400">
						Select a color theme to match your brand's look and feel
					</p>

					<v-select
						v-model="config.panelTheme"
						:items="themes"
						item-text="name"
						item-value="value"
						solo
						hide-details
						flat
						background-color="purple"
						color="textColor"></v-select>
				</section>

				<img
					v-if="config.panelTheme"
					width="100%"
					:src="require(`@/assets/images/previews/${config.panelTheme}.png`)"
					alt="Theme Preview" />
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import { mdiAlertCircleOutline } from '@mdi/js';
import { ref } from '@vue/composition-api';

export default {
	props: {
		config: {
			type: Object,
			required: true,
		},
	},
	setup(props) {
		const themes = [
			{ name: 'Violet', value: 'violet', gradient: '#7649d4, #9865f8, #7649d4' },
			{ name: 'Blue', value: 'blue', gradient: '#006DD9, #00B2EE, #006DD9' },
			{ name: 'Green', value: 'green', gradient: '#00A52A, #00D235, #00A62A' },
			{ name: 'Orange', value: 'orange', gradient: '#ea6700, #e48100ee, #ea6700' },
			{ name: 'Pink', value: 'pink', gradient: '#FF3E72, #FF4676, #FF4173' },
			{ name: 'Purple', value: 'purple', gradient: '#f30ae9, #ff54f2, #f40de9' },
			{ name: 'Red', value: 'red', gradient: '#a5001e, #ab001f, #a5001e' },
			{ name: 'Turquoise', value: 'turquoise', gradient: '#009e89, #00c0ab, #00a08b' },
			{ name: 'Yellow', value: 'yellow', gradient: '#FFB000, #FFB434, #FFB000' },
			{ name: 'Grey', value: 'grey', gradient: '#58717d, #6f8b98, #58737f' },
		];
		return {
			themes,
			icons: {
				mdiAlertCircleOutline,
			},
		};
	},
};
</script>
